<script setup lang="ts">
import { countBy, keyBy } from "lodash-es";
import { computed } from "vue";

import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import type { BoardCard } from "@/model/card";

const props = defineProps<{ cards: BoardCard[] }>();

const rows = computed(() => {
  const counts = countBy(props.cards, (c) => c.data.type.id);
  const firstByType = keyBy(props.cards, (c) => c.data.type.id);
  return Object.entries(counts)
    .map(([id, count]) => {
      const { name, color } = firstByType[id].data.type;
      return { id, count, name, color, label: `${count} ${name}` };
    })
    .sort((a, b) => b.count - a.count || a.name.localeCompare(b.name));
});
</script>

<template>
  <ul class="sticky-type-breakdown">
    <li v-for="row in rows" :key="row.id" class="row">
      <TypeDot :color="row.color" size="medium" />
      <span class="label">{{ row.label }}</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";

.sticky-type-breakdown {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .row {
    display: flex;
    align-items: center;
    gap: 8px;

    .label {
      @include typography.medium("semi-bold");

      font-variant-numeric: tabular-nums; // All numbers should have the same width for better readability
    }
  }
}
</style>
